import { render, staticRenderFns } from "./ResourceType.vue?vue&type=template&id=3290a219"
import script from "./ResourceType.vue?vue&type=script&lang=js"
export * from "./ResourceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3290a219')) {
      api.createRecord('3290a219', component.options)
    } else {
      api.reload('3290a219', component.options)
    }
    module.hot.accept("./ResourceType.vue?vue&type=template&id=3290a219", function () {
      api.rerender('3290a219', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/ResourceType.vue"
export default component.exports